// extracted by mini-css-extract-plugin
export var deleteModal = "_gp-0";